<script>
  import Registration from '$components/blocks/club/Registration.svelte';
  import striptags from 'striptags';
  import { _ } from 'svelte-i18n';
</script>

<svelte:head>
  <title>{striptags($_('page.club.registration.title'))}</title>
</svelte:head>

<Registration />
